import { render, staticRenderFns } from "./DBindNew.vue?vue&type=template&id=97633e24"
import script from "./DBindNew.vue?vue&type=script&lang=js"
export * from "./DBindNew.vue?vue&type=script&lang=js"
import style0 from "./DBindNew.vue?vue&type=style&index=0&id=97633e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports